export const CSessionConfirmationTime = [
  30,
  60,
  90,
  120,
  150,
  180,
  210,
  240,
  270,
  300,
];
